export var HELP_MESSAGE_PREFIX = 'ui-czna-authorities.';
var HELP_PATTERN = /help/i;
var ARIA_LABEL_PATTERN = /arialabel$/i;
export var isHelpMessageId = function (id) {
    if (!id.startsWith(HELP_MESSAGE_PREFIX))
        return false;
    var key = id.substring(HELP_MESSAGE_PREFIX.length);
    return HELP_PATTERN.test(key) && !ARIA_LABEL_PATTERN.test(key);
};
/** Overrides are written by NK in Czech; under any other locale the packaged text stays. */
export var overridesApplyTo = function (locale) {
    return typeof locale === 'string' && locale.toLowerCase().startsWith('cs');
};
/**
 * `@formatjs/icu-messageformat-parser`'s element `type` values. Spelled out here because the
 * parser is only a devDependency of this module; react-intl hands us its AST through
 * `getMessageFormat(...).getAst()`.
 */
var ARGUMENT_TYPES = new Set([1, 2, 3, 4, 5, 6]); // argument, number, date, time, select, plural
var TAG_TYPE = 8;
var collectNames = function (elements, args, tags) {
    elements.forEach(function (element) {
        var _a, _b;
        if (ARGUMENT_TYPES.has(element.type) && typeof element.value === 'string') {
            args.add(element.value);
        }
        if (element.type === TAG_TYPE && typeof element.value === 'string') {
            tags.add(element.value);
            collectNames((_a = element.children) !== null && _a !== void 0 ? _a : [], args, tags);
        }
        Object.values((_b = element.options) !== null && _b !== void 0 ? _b : {}).forEach(function (option) { return collectNames(option.value, args, tags); });
    });
};
/** Placeholder and tag names of `message`, or `null` when it does not parse. */
var namesOf = function (message, intl) {
    try {
        var ast = intl.formatters.getMessageFormat(message, intl.locale).getAst();
        var args = new Set();
        var tags = new Set();
        collectNames(ast, args, tags);
        return { args: args, tags: tags };
    }
    catch (_a) {
        return null;
    }
};
/**
 * Why `text` cannot stand in for `defaultMessage`, or `null` when it can. The Settings
 * editor shows the reason; the override layer only needs to know there is one.
 */
export var overrideProblem = function (text, defaultMessage, intl) {
    var _a, _b;
    if (typeof text !== 'string' || text.trim() === '') {
        return 'empty';
    }
    var own = namesOf(text, intl);
    if (own === null) {
        return 'syntax';
    }
    var packaged = typeof defaultMessage === 'string' ? namesOf(defaultMessage, intl) : null;
    var allowedArgs = (_a = packaged === null || packaged === void 0 ? void 0 : packaged.args) !== null && _a !== void 0 ? _a : new Set();
    var allowedTags = new Set(Object.keys((_b = intl.defaultRichTextElements) !== null && _b !== void 0 ? _b : {}));
    packaged === null || packaged === void 0 ? void 0 : packaged.tags.forEach(function (name) { return allowedTags.add(name); });
    var unknownArg = Array.from(own.args).some(function (name) { return !allowedArgs.has(name); });
    var unknownTag = Array.from(own.tags).some(function (name) { return !allowedTags.has(name); });
    return unknownArg || unknownTag ? 'unknownPlaceholder' : null;
};
/**
 * The overrides that may replace a packaged message: help ids that exist in `baseMessages`,
 * under a Czech locale, with no `overrideProblem`. Returns an empty object otherwise.
 */
export var usableOverrides = function (overrides, baseMessages, intl) {
    var usable = {};
    if (!overrides || !overridesApplyTo(intl.locale)) {
        return usable;
    }
    Object.entries(overrides).forEach(function (_a) {
        var id = _a[0], text = _a[1];
        if (isHelpMessageId(id)
            && Object.prototype.hasOwnProperty.call(baseMessages, id)
            && overrideProblem(text, baseMessages[id], intl) === null) {
            usable[id] = text;
        }
    });
    return usable;
};
